import { useAuthActions } from "../../AuthWrapper2/hooks/useAuthActions.js";
import { useCurrentIdentityInfo } from "../../AuthWrapper2/hooks/useCurrentIdentityInfo.js";
import { useAppList } from "../../AppWrapper2/hooks/useAppList.js";
import { UserListItem } from "../shared/UserListItem.js";
import { useCallback, useMemo } from "react";
import { Button, ButtonGroup } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
// src/modules/Users/screens/UserSidePanelScreen.tsx
function UserSidebarScreen() {
	const { changeUser, logout } = useAuthActions();
	const identityInfo = useCurrentIdentityInfo();
	const { appList } = useAppList();
	const profileLink = useMemo(() => {
		return appList.find((app) => app.id === "profile")?.link;
	}, [appList]);
	const currentUser = identityInfo.users.find((u) => u.user.id === identityInfo.user.id);
	const sortedUsers = identityInfo.users.sort((a, b) => {
		return a.user.displayName > b.user.displayName ? -1 : 1;
	});
	const onUserClick = useCallback((newUserId) => {
		changeUser(newUserId);
	}, [changeUser]);
	return /* @__PURE__ */ jsxs("div", {
		className: "space-y-base flex h-full flex-col",
		children: [
			!!currentUser && /* @__PURE__ */ jsxs("div", {
				className: "space-y-sm",
				children: [/* @__PURE__ */ jsx("div", {
					className: "px-base pt-base text-color-subtle font-bold tracking-wider uppercase",
					children: "CURRENT USER"
				}), /* @__PURE__ */ jsx("div", {
					className: "px-lg",
					children: /* @__PURE__ */ jsx(UserListItem, { userData: currentUser })
				})]
			}),
			/* @__PURE__ */ jsx("div", {
				className: "pt-xs px-base",
				children: /* @__PURE__ */ jsxs(ButtonGroup, {
					fullWidth: true,
					children: [!!profileLink && /* @__PURE__ */ jsx(Button, {
						className: "p-0",
						children: /* @__PURE__ */ jsx("a", {
							href: profileLink,
							children: "User Profile"
						})
					}), /* @__PURE__ */ jsx(Button, {
						onClick: logout,
						children: "Logout"
					})]
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "space-y-xs flex grow flex-col overflow-y-auto",
				children: sortedUsers.length > 1 && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("div", {
					className: "px-base pt-base text-color-subtle text-sm font-bold tracking-wide uppercase",
					children: "Switch Account"
				}), /* @__PURE__ */ jsx("div", {
					className: "space-y-xxs grow overflow-y-auto",
					children: sortedUsers.map((userData) => userData.user.id !== identityInfo.user.id && /* @__PURE__ */ jsx("div", {
						className: classnames("mt-sm px-lg py-sm hover:bg-surface hover:text-color-strong cursor-pointer rounded-md text-left transition duration-150 ease-in-out"),
						onClick: () => onUserClick(userData.user.id),
						children: /* @__PURE__ */ jsx(UserListItem, { userData })
					}, userData.user.id))
				})] })
			})
		]
	});
}
export { UserSidebarScreen };

//# sourceMappingURL=UserSidePanelScreen.js.map